export const RECEIVE_LIQUORS = 'RECEIVE_LIQUORS';
export const UPDATE_DEPARTMENT = 'UPDATE_DEPARTMENT';
export const ADD_FILTER = 'ADD_FILTER';
export const REMOVE_FILTER = 'REMOVE_FILTER';
export const UPDATE_FILTER = 'UPDATE_FILTER';

// cart
export const RECEIVE_CART_AND_USER_PROFILE = 'RECEIVE_CART_AND_USER_PROFILE';
export const EMPTY_CART = 'EMPTY_CART';
export const ADD_TO_CART = 'ADD_TO_CART';
export const SET_AMOUNT = 'SET_AMOUNT';

// alert
export const ERROR = 'ERROR';
export const SUCCESS = 'SUCCESS';

// user
export const LOGGED_IN = 'LOGGED_IN';
export const LOGGED_OUT = 'LOGGED_OUT';
